import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { CRMTypesResponse, RxJSStateDefinable } from '../Types/Types'

const crmTypesSubject: BehaviorSubject<Definable<CRMTypesResponse[]>> = new BehaviorSubject<
    Definable<CRMTypesResponse[]>
>([])

RxJS.crmTypes = RxJS.crmTypes ?? {
    subject: crmTypesSubject,
    observable: crmTypesSubject.asObservable(),
    announce: (types?: CRMTypesResponse[]): void => {
        crmTypesSubject.next(types ?? [])
    }
}

export const crmTypes$: RxJSStateDefinable<CRMTypesResponse[]> = RxJS.crmTypes
